export const C4Context = {
	Country: 'UAE',
	City: '02',
	Sector: '020026',
	Community: '0200260269',
	Plot: '0200260269_C4',
	Building: '190405',
	Floor: '',
	Unit: '',
	Asset: '',
	CurrentFocus: 'Building',
};
